import { Row, Col, Popconfirm, Select as AntSelect } from "antd"
import { Formik, FormikProps } from "formik";
import { FC } from "react";
import { data } from "../../../constants";
import { Switch } from "../../atoms/Switch";
import { InputWithLabel } from "../../molecules/InputWithLabel";
import { SelectWithLabel } from "../../molecules/SelectWithLabel";
import { AccountStatusText, AccountStatusWrapper, ErrorMessage, StatusInfoText, StatusInfoWrapper } from "./elements";
import { CreateUserFormSchema } from "./validation";

const { Option } = AntSelect;

export type AddNewUserType = {
  fullName: string;
  email: string; 
  accessType: string; 
  password: string;
};

type Props = {
  onCreateUser: (values: AddNewUserType) => void;
  innerRef?: React.Ref<FormikProps<any>>;
  popConfirmVisible?: boolean;
  handleSwitchStatus: (checked: boolean) => void;
  isAccountActive: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isSuperAdmin?: boolean;
};

const CreateUserForm: FC<Props> = ({ 
  isAccountActive, 
  onCreateUser, 
  innerRef, 
  popConfirmVisible, 
  handleSwitchStatus, 
  onConfirm, 
  onCancel,
  isSuperAdmin,
})  => {

  const accessTypes = isSuperAdmin ? [
    ...data.userAccessType,
    'Admin'
  ] : data.userAccessType;

  return (
    <Formik
      innerRef={innerRef}
      onSubmit={onCreateUser}
      initialValues={{ fullName: '', email: '', accessType:  '', password: '', accountStatus: ''}}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={CreateUserFormSchema}>
      {({ values, handleChange, handleSubmit, errors }) => (
        <form onSubmit={handleSubmit}>
            <Row gutter={[16, 0]}>
              <Col span={12}>
                  <InputWithLabel error={!!errors.fullName} value={values.fullName} onChange={handleChange('fullName')} label="Full Name" type="default" />
                  {errors.fullName && (<ErrorMessage>{errors.fullName}</ErrorMessage>)}
              </Col>
              <Col span={12}>
                  <InputWithLabel error={!!errors.email} value={values.email} onChange={handleChange('email')} label="Email Address" type="default" />
                  {errors.email && (<ErrorMessage>{errors.email}</ErrorMessage>)}
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col span={12}>
                  <SelectWithLabel 
                    selectOnChange={handleChange('accessType')} 
                    selectDefaultValue={values.accessType} 
                    label="Access Type" 
                    error={!!errors.accessType}
                    optionItems={
                      <>
                        {accessTypes.map((status: string) => (
                          <Option
                            key={status}
                            value={status.toLowerCase()}
                          >
                            {status}
                          </Option>
                        ))}
                      </>
                    }
                  />
                  {errors.accessType && (<ErrorMessage>{errors.accessType}</ErrorMessage>)}
              </Col>
              <Col span={12}>
                  <InputWithLabel error={!!errors.password} value={values.password} onChange={handleChange('password')} label="Password" type="password" />
                  {errors.password && (<ErrorMessage>{errors.password}</ErrorMessage>)}
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col span={12} offset={12}>
                  <AccountStatusWrapper>
                    <AccountStatusText>Account Status</AccountStatusText>
                    <StatusInfoWrapper>
                      <Popconfirm 
                        destroyTooltipOnHide={{ keepParent: false }}
                        getPopupContainer={(trigger: any) =>  trigger.parentElement}
                        placement="bottomRight"
                        visible={popConfirmVisible}
                        title="Are you sure you want to update the user's account status?"  
                        okText="Yes"
                        cancelText="Cancel"
                        cancelButtonProps={{ size: 'middle' ,danger: true,  type: 'text' }}
                        okButtonProps={{size: 'middle'}}
                        onCancel={onCancel}
                        onConfirm={onConfirm}>
                        <Switch checked={isAccountActive} onChange={handleSwitchStatus} />
                      </Popconfirm>
                      <StatusInfoText style={{marginLeft: '.5em'}}>{isAccountActive ? 'Active' : 'Suspended'}</StatusInfoText>
                    </StatusInfoWrapper>
                  </AccountStatusWrapper>
              </Col>
        </Row>
        </form>
      )}
    </Formik>
  )
}

export default CreateUserForm;
